import React from 'react';
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="relative py-16 sm:py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <img
          src="/images/dakar-driver.png"
          alt="Luxury travel"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-4 sm:px-6 text-center">
        <h2
          className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-white mb-4 sm:mb-6"
          style={{ fontFamily: 'Playfair Display, serif' }}
        >
          Il est temps de voyager autrement.
        </h2>
        <p className="text-sm sm:text-lg text-white/80 mb-8 sm:mb-10 max-w-2xl mx-auto leading-relaxed">
          Ne vous contentez pas de l'ordinaire. Découvrez nos solutions de transport conçues pour votre confort.
        </p>
        <Link
          to="/contact"
          className="inline-block px-8 sm:px-10 py-3 sm:py-4 border-2 border-white text-white text-xs sm:text-sm uppercase tracking-wider hover:bg-white hover:text-gray-900 transition-all duration-300 rounded-full hover:scale-105"
        >
          Demander un devis
        </Link>
      </div>
    </section>
  );
};

export default CTASection;
